/**
 * 去除收尾空格
 * @param {Object} str
 */
export function trimStr (str) {
  return str.toString().replace(/(^\s*)|(\s*$)/g, '')
}

/**
 * 是否英文
 * @param {Object} str
 */
export function isEn (str) {
  // eslint-disable-next-line prefer-regex-literals
  const pattern = new RegExp('[A-Za-z]+')
  return pattern.test(str)
}

/**
 * 是否数字
 * @param {Object} str
 */
export function isDigital (str) {
  // eslint-disable-next-line prefer-regex-literals
  const pattern = new RegExp('[0-9]+')
  return pattern.test(str)
}

/**
 * 是否中文
 * @param {Object} str
 */
export function isZh (str) {
  // eslint-disable-next-line prefer-regex-literals
  const pattern = new RegExp('[\u4E00-\u9FA5]+')
  return pattern.test(str)
}

/**
 * 计算有效的长度
 * @param {Object} str
 */
export function countValidStrLen (str) {
  const strTmp = str.replace(/\[\d+\.\d+秒\]|\[=[a-z]+\d]|\s+/g, '')
  return strTmp.length
}

/**
 * 生成指定长度的随机字符串
 * @param {Object} len
 */
export function randomString (e) {
  e = e || 32
  const t = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
  const a = t.length
  let n = ''
  for (let i = 0; i < e; i++) n += t.charAt(Math.floor(Math.random() * a))
  return n
}

/**
 * @param {Object} str
 */
export function phoneCheck (str) {
  // const phoneReg = new RegExp("^((13[0-9])|(14[0-9])|(15[0-9])|(16[0-9])|(17[0-9])|(18[0-9])|(19[0-9]))\d{8}$");
  const phoneReg = /^((13[0-9])|(14[0-9])|(15[0-9])|(16[0-9])|(17[0-9])|(18[0-9])|(19[0-9]))\d{8}$/
  return phoneReg.test(str)
}
